import { ForgotPasswordRequestModel, OtpVerificationModel } from "../models/OtpVerificationModel";
import { ResponseModel } from "../models/ResponseModel";
import { UpdatePasswordModel } from "../models/UpdatePasswordModel";
import { AjaxService } from "../shared/services/AjaxService";

const openRequestOptions = {
    includeSessionAuth: false,
    clearSessionOnUnauthorized: false,
};

const tempTokenOptions = (temporaryToken: string) => ({
    authToken: `Bearer ${temporaryToken}`,
    includeSessionAuth: false,
    clearSessionOnUnauthorized: false,
});

export const ForgotMPINService = {

    async getForgotPasswordConfig(): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>("/User/getForgotPasswordConfig", openRequestOptions);
    },

    async sendOtp(payload: ForgotPasswordRequestModel): Promise<ResponseModel> {
        const params = new URLSearchParams();

        if (payload.mobileNumber) {
            params.append("mobileNumber", payload.mobileNumber);
        }

        if (payload.email) {
            params.append("email", payload.email);
        }

        return AjaxService.get<ResponseModel>(
            `/User/forgotPassword?${params.toString()}`,
            openRequestOptions
        );
    },

    async verifyOtp(payload: OtpVerificationModel, temporaryToken: string): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>(
            "/User/forgotOtpVerify",
            payload,
            tempTokenOptions(temporaryToken)
        );
    },

    async updatePassword(payload: UpdatePasswordModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/updatePassword", payload, openRequestOptions);
    },
}
